import React from "react";
import { motion } from "framer-motion";

/**
 * Reusable SectionHeader component.
 * Props: tag, title, subtitle, centered (bool)
 */
const SectionHeader = ({ tag, title, subtitle, centered = false }) => {
  return (
    <div className={centered ? "text-center" : ""}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="section-tag"
      >
        {tag}
      </motion.div>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="font-display font-extrabold text-white leading-tight tracking-tight mb-4"
        style={{ fontSize: "clamp(1.9rem, 4vw, 2.9rem)", letterSpacing: "-0.03em" }}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-base leading-7 max-w-xl"
          style={{ color: "var(--slate)" }}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
};

export default SectionHeader;
